import React from "react";

import { Panel } from "../AdminAnalyticsCards";
import { aa, asArray } from "../adminAnalyticsUtils";

export default function AdminAnalyticsTable({
  title,
  rows,
  columns,
  rowKey,
  emptyMessage = aa("no_data_for_period", "No data for this period."),
  className = "",
  minWidth = 680,
}) {
  const safeRows = asArray(rows);
  const safeColumns = asArray(columns);

  return (
    <Panel
      title={title}
      className={`admin-analytics-table-panel ${className}`.trim()}
    >
      {safeRows.length > 0 ? (
        <div className="admin-analytics-table-wrap">
          <table
            className="admin-analytics-table"
            style={{ minWidth: `${minWidth}px` }}
          >
            <thead>
              <tr>
                {safeColumns.map((column) => (
                  <th key={column.header}>{column.header}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {safeRows.map((row, index) => (
                <tr key={rowKey ? rowKey(row, index) : index}>
                  {safeColumns.map((column) => (
                    <td key={column.header}>
                      {column.render
                        ? column.render(row, index)
                        : String(row?.[column.accessor] ?? "")}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <p className="admin-analytics-panel__empty">{emptyMessage}</p>
      )}
    </Panel>
  );
}

export function UserCell({ title, subtitle }) {
  return (
    <>
      <strong>{title}</strong>
      {subtitle ? <span>{subtitle}</span> : null}
    </>
  );
}
